<template>
  <div class="relative text-base pl-3">
    <div class="mt-8 flex items-center">
      <span class="w-12">From</span>
      <time-input type="from"
                  :value="timeFrom"
                  ref="fromInput"
                  class="flex-grow"
                  placeholder="08:00"
                  :autofocus="isTimeFromInputError"
                  :has-error="isTimeFromInputError"
                  @change="from => updateTimeBetween(from, timeTo)"/>
    </div>

    <div class="mt-2 flex items-center">
      <span class="w-12">To</span>
      <time-input type="to"
                  :value="timeTo"
                  ref="toInput"
                  class="flex-grow"
                  placeholder="18:00"
                  :autofocus="isTimeToInputError"
                  :has-error="isTimeToInputError"
                  @change="to => updateTimeBetween(timeFrom, to)"/>
    </div>

    <span v-if="isTimeFromInputError || isTimeToInputError" class="text-focus-error text-xs mt-1 absolute">
      {{ errorDescription }}
    </span>
  </div>
</template>

<script>
import { CONDITION_CASES } from '@/store/constants'
import conditionUtils from '@/utils/condition.utils'
import TimeInput from '@/components/common/TimeInput'
import chatBubbleModule from '@/store/modules/chat-bubble.module'
import previewModule from '@/store/modules/preview.module'

export default {
  name: 'TimeBetweenEditor',

  components: { TimeInput },

  props: {
    timeBetween: {
      type: Object,
      required: true
    }
  },

  computed: {
    errorDescription: previewModule.errorDescription,
    errorPath: previewModule.errorPath,

    isTimeFromInputError() {
      return chatBubbleModule.isErrorBubbleFocused() && this.errorPath.includes('from')
    },

    isTimeToInputError() {
      return chatBubbleModule.isErrorBubbleFocused() && this.errorPath.includes('to')
    },

    timeFrom() {
      return this.timeBetween.from
    },

    timeTo() {
      return this.timeBetween.to
    }
  },

  methods: {
    updateTimeBetween(from, to) {
      this.$emit('condition-change', conditionUtils.createConditionJson(CONDITION_CASES.TIME_BETWEEN, {
        from,
        to
      }))
    }
  }
}
</script>
